import i18n from './index';
import ptBR from './locales/pt-BR/marketingSegment.json';
import en from './locales/en/marketingSegment.json';

/**
 * Namespace da plataforma Marketing, registrado pelo próprio módulo (efeito
 * colateral do import) em vez de na lista central de i18n/index.ts — mantém o
 * segmento autocontido. Todo componente do segmento importa este arquivo antes
 * de chamar useTranslation(MARKETING_NS).
 */
export const MARKETING_NS = 'marketingSegment';

if (!i18n.hasResourceBundle('pt-BR', MARKETING_NS)) {
  i18n.addResourceBundle('pt-BR', MARKETING_NS, ptBR, true, true);
}
if (!i18n.hasResourceBundle('en', MARKETING_NS)) {
  i18n.addResourceBundle('en', MARKETING_NS, en, true, true);
}
